import { Table } from './Table';
import { TBody } from './TBody';
import { Media } from './Media';

export default {
  table: Table,
  tbody: TBody,
  img: Media,
};
